import React, { Fragment } from "react"
import type { ComponentType } from "react"
import moment from "moment"

import type { KnowledgeItem } from "../../../types/types"
import { images, flagsMapping } from "../../../config/image-definitions"
import BackgroundImage from "../BackgroundImage"
import ExpandableIcon from "../ExpandableIcon"
import SpinnerImage from "../SpinnerImage"
import ModerationIcon from "./ModerationIcon"
import KnowledgeLinkButton from "./KnowledgeLinkButton"
import SideRemoveButton from "../SideRemoveButton"
import SideCheckBox from "../SideCheckBox"

type Props = KnowledgeItem & {
    activeId: string,
    onClick: string => void,
    summary?: string,
    isFetching: boolean,
    isExpanded: boolean,
    toggleExpansion: string => void,
    showApproved: boolean,
    showAddedOn: boolean,
    expansionLinkComponent: ComponentType<any>
}

const KnowledgeListItem = (props: Props) => {
    const {
        id,
        activeId,
        image,
        title,
        approved,
        approval_suggestion,
        publisher,
        language,
        time,
        time_analyzed,
        has_source,
        onClick,
        summary,
        isFetching,
        isExpanded,
        toggleExpansion,
        showApproved,
        onRemoveClick,
        isChecked,
        showCheckbox = false,
        showAddedOn = true,
        expansionLinkComponent: ExpansionLinkComponent = KnowledgeLinkButton
    } = props
    const activeClassName = `${id === activeId ? "active" : ""}`
    return (
        <div
            className={`list-group-item list-group-item-action align-items-start ${activeClassName}`}
            onClick={onClick ? onClick(id) : () => null}
        >
            <BackgroundImage
                classList={["list-group-item-thumb"]}
                imageUrl={image}
                isThumbnail={true}
            >
                <div className="thumb-cover" />
                {showApproved && (
                    <ModerationIcon
                        approved={approved}
                        approvalSuggestion={approval_suggestion}
                        isButton={false}
                    />
                )}
            </BackgroundImage>
            <div className="list-group-item-content">
                <h4>{title}</h4>
                {showAddedOn && (
                    <p>Added on: {moment.unix(time_analyzed).format("llll")}</p>
                )}
                <p>
                    {showAddedOn && "Published on: "}
                    {moment.unix(time).format("llll")}
                </p>
                <p style={{ paddingRight: "45px" }}>{publisher}</p>
                {has_source === false && (
                    <img
                        src={images.peoplePlaceholder}
                        className="item-flag"
                        alt="This article was submitted by a user"
                        style={{ right: "40px" }}
                    />
                )}
                {language && (
                    <img
                        src={flagsMapping[language]}
                        className="item-flag"
                        alt={language}
                    />
                )}
                {onRemoveClick && (
                    <SideRemoveButton onClick={onRemoveClick(id)} />
                )}
                {showCheckbox && <SideCheckBox isAdded={isChecked} />}
            </div>
            {toggleExpansion && <ExpandableIcon isExpanded={isExpanded} />}
            {isExpanded &&
                (isFetching ? (
                    <SpinnerImage central={true} />
                ) : (
                    <Fragment>
                        <p className="expanded-content">{summary}</p>
                        <ExpansionLinkComponent {...props} />
                    </Fragment>
                ))}
        </div>
    )
}

export default KnowledgeListItem
